// ===========================================
// konakla - Sabitler ve Konfigürasyon
// ===========================================

// Site Bilgileri
export const SITE_CONFIG = {
  name: "konakla",
  slogan: "Türkiye'nin komisyonsuz kısa süreli konaklama platformu.",
  description:
    "Türkiye'nin komisyonsuz kısa süreli konaklama platformu. Belgeli evlerde ev sahibiyle doğrudan iletişime geçin.",
  url: "https://konakla.co",
  email: "info@konakla.co",
} as const;

// Renkler
export const COLORS = {
  primary: "#162ee0",
  primaryLight: "#4f6af5",
  primaryDark: "#0f1f9e",
  background: "#ffffff",
  foreground: "#0a0a0a",
  muted: "#737373",
  accent: "#eff1fe",
} as const;

// Mülk Tipleri
export const PROPERTY_TYPES = {
  villa: "Villa",
  apart: "Apart",
  bungalov: "Bungalov",
  daire: "Daire",
  yazlik: "Yazlık",
  other: "Diğer",
} as const;

// Popüler Bölgeler
export const POPULAR_LOCATIONS = [
  { city: "Antalya", district: "Kaş", slug: "antalya-kas" },
  { city: "Antalya", district: "Kalkan", slug: "antalya-kalkan" },
  { city: "Antalya", district: "Kemer", slug: "antalya-kemer" },
  { city: "Muğla", district: "Fethiye", slug: "mugla-fethiye" },
  { city: "Muğla", district: "Bodrum", slug: "mugla-bodrum" },
  { city: "Muğla", district: "Marmaris", slug: "mugla-marmaris" },
  { city: "İzmir", district: "Çeşme", slug: "izmir-cesme" },
  { city: "İzmir", district: "Alaçatı", slug: "izmir-alacati" },
  { city: "Aydın", district: "Kuşadası", slug: "aydin-kusadasi" },
  { city: "Çanakkale", district: "Bozcaada", slug: "canakkale-bozcaada" },
] as const;

// Olanaklar (Amenities)
export const AMENITIES = {
  pool: { label: "Havuz", icon: "waves" },
  seaView: { label: "Deniz Manzarası", icon: "sunset" },
  mountainView: { label: "Dağ Manzarası", icon: "mountain" },
  parking: { label: "Otopark", icon: "car" },
  wifi: { label: "Wi-Fi", icon: "wifi" },
  airConditioning: { label: "Klima", icon: "wind" },
  heating: { label: "Isıtma", icon: "flame" },
  kitchen: { label: "Mutfak", icon: "utensils" },
  washingMachine: { label: "Çamaşır Makinesi", icon: "shirt" },
  tv: { label: "TV", icon: "tv" },
  balcony: { label: "Balkon", icon: "door-open" },
  garden: { label: "Bahçe", icon: "trees" },
  bbq: { label: "Barbekü", icon: "flame" },
  petFriendly: { label: "Evcil Hayvan", icon: "paw-print" },
} as const;

// İptal politikası hazır şablonları — ilan ekleme sihirbazındaki "İptal Politikası"
// alanı için hızlı doldurma. Kullanıcı yine de metni serbestçe düzenleyebilir
// (düzenleyince "Özel" duruma geçer). cancellationPolicy alanı düz metin string'idir.
export const CANCELLATION_POLICY_TEMPLATES = [
  {
    key: "flexible",
    label: "Esnek",
    text: "Esnek iptal politikası: Giriş tarihinden 7 gün öncesine kadar yapılan iptallerde tam iade. Son 7 gün içindeki iptallerde ilk gece bedeli tahsil edilir, kalan tutar iade edilir.",
  },
  {
    key: "moderate",
    label: "Orta",
    text: "Orta iptal politikası: Giriş tarihinden 14 gün öncesine kadar yapılan iptallerde tam iade. 14 gün içindeki iptallerde %50 iade. Giriş günü yapılan iptallerde iade yapılmaz.",
  },
  {
    key: "strict",
    label: "Katı",
    text: "Katı iptal politikası: Giriş tarihinden 30 gün öncesine kadar yapılan iptallerde %50 iade. Son 30 gün içindeki iptallerde iade yapılmaz.",
  },
] as const;

export const DEFAULT_CANCELLATION_POLICY = CANCELLATION_POLICY_TEMPLATES[1].text; // Orta

// Yıllık ödemede uygulanan indirim oranı (0.20 = %20)
export const YEARLY_DISCOUNT = 0.2;

// Abonelik iade penceresi (gün) — ilk satın almadan sonra bu süre içinde iptal eden
// kullanıcı tam iade alır ve ilanları o sürenin sonuna kadar yayında kalır.
// Süre dolunca cron expired aboneliği free'ye düşürür ve fazla ilanları pasife alır.
// SSS metni de aynı süreyi yansıtır (lib/data/faq.ts).
export const REFUND_WINDOW_DAYS = 14;

/**
 * Yenileme ödemesi başarısız olduğunda verilen ek süre (gün).
 *
 * Y-28: bu değer İKİ yerde kullanılıyor — yenileme cron'u ve IPN webhook'unun
 * grace dalı. Eskiden cron'da sabit, webhook'ta ise elle yazılmış `3` vardı;
 * biri değiştirilirse diğeri sessizce sapardı. Kullanıcıya giden e-posta da
 * bu sayıyı yazıyor ("{graceDays} gün ek süre verdik").
 */
export const SUBSCRIPTION_GRACE_DAYS = 3;

/**
 * Plan sırası — yükseltme/düşürme ayrımı için.
 *
 * K-9: bu tablo VARDI ama YALNIZCA istemcide (`components/pricing/pricing-cards.tsx`).
 * Sunucu tarafındaki `calculateUpgradeAmount` plan sırasına hiç bakmıyordu:
 * "yükseltme" tanımı sadece "mevcut plan free değil" idi. Sonuç olarak AYNI planı
 * tekrar satın almak da yükseltme sayılıyor ve pro-rata kredisi tam fiyatı
 * karşıladığında kullanıcı ÖDEME YAPMADAN dönemini uzatabiliyordu.
 * Artık tek kaynak burası; istemci de buradan okuyor.
 */
export const PLAN_RANK = { free: 0, plus: 1, pro: 2 } as const;

// Abonelik Planları
// Tek gerçek kaynak (SSOT). UI bileşenleri ve API limit kontrolü buradan okur.
// monthlyPriceOriginal/yearlyPriceOriginal: üstü çizili gösterilen "lansman öncesi" fiyatlar.
// listingLimit === -1 → sınırsız.
export const SUBSCRIPTION_PLANS = {
  free: {
    key: "free",
    name: "Ücretsiz",
    tagline: "Tek mülk sahipleri için",
    listingLimit: 1,
    monthlyPrice: 0,
    monthlyPriceOriginal: null,
    yearlyPrice: 0,
    yearlyPriceOriginal: null,
    popular: false,
    features: [
      "1 ilan hakkı",
      "Sınırsız görüntülenme",
      "Direkt iletişim (komisyonsuz)",
      "iCal entegrasyonu",
      "Temel analitik",
      "E-posta destek",
    ],
    ctaLabel: "Ücretsiz Başla",
  },
  plus: {
    key: "plus",
    name: "Plus",
    tagline: "Birden fazla mülk için",
    listingLimit: 5,
    monthlyPrice: 699,
    monthlyPriceOriginal: 999,
    yearlyPrice: 6710, // 699 * 12 * 0.8 = 6710.4
    yearlyPriceOriginal: 9590, // 999 * 12 * 0.8 = 9590.4
    popular: false,
    features: [
      "2-5 ilan hakkı",
      "Öncelikli listeleme",
      "iCal entegrasyonu",
      "Detaylı analitik",
      "Öncelikli destek",
    ],
    ctaLabel: "Plus'a Geç",
  },
  pro: {
    key: "pro",
    name: "Pro",
    tagline: "Profesyonel işletmeler ve acentalar için",
    listingLimit: -1,
    monthlyPrice: 1299,
    monthlyPriceOriginal: 1999,
    yearlyPrice: 12470, // 1299 * 12 * 0.8 = 12470.4
    yearlyPriceOriginal: 19190, // 1999 * 12 * 0.8 = 19190.4
    popular: true, // "En Çok Tercih Edilen" rozeti
    features: [
      "Sınırsız ilan hakkı",
      "Tüm Plus özellikleri",
      "iCal entegrasyonu",
      "Gelişmiş analitik ve raporlama",
      "Özel hesap yöneticisi",
      "7/24 öncelikli destek",
    ],
    ctaLabel: "Pro'ya Geç",
  },
} as const;

export type SubscriptionPlanKey = keyof typeof SUBSCRIPTION_PLANS;
export type BillingPeriod = "monthly" | "yearly";

export const SUBSCRIPTION_PLAN_KEYS: SubscriptionPlanKey[] = ["free", "plus", "pro"];

// ===========================================
// Davet Programı
// ===========================================

/** Özelliğin kullanıcıya görünen adı/sloganı. Tek kaynak burasıdır. */
export const DAVET_SLOGAN = "Davet Et, Önde Ol!";

/**
 * Ödül penceresi (gün).
 *
 * ⚠️ Migration 025'teki `v_gun constant integer := 30` ile BİREBİR AYNI olmalı.
 * Ödülü GERÇEKTEN veren yer veritabanıdır; buradaki değer yalnızca arayüz
 * metinlerinde kullanılır. İkisi ayrışırsa kullanıcıya yanlış süre vaat edilir —
 * ve teslim edilmeyen vaat, K-12'de yaşandığı gibi doğrudan hukuki risktir.
 */
export const DAVET_ODUL_GUN = 30;

// Sıralama Seçenekleri
export const SORT_OPTIONS = [
  { value: "recommended", label: "Önerilen" },
  { value: "price_asc", label: "Fiyat (Artan)" },
  { value: "price_desc", label: "Fiyat (Azalan)" },
  { value: "rating", label: "En Yüksek Puanlı" },
  { value: "newest", label: "En Yeni" },
] as const;

// Sayfalama
export const PAGINATION = {
  defaultLimit: 12,
  maxLimit: 48,
} as const;

// Not: Rate limit konfigürasyonları lib/rate-limit.ts içinde tanımlıdır
// Oradan import edin: import { RATE_LIMIT_CONFIGS } from "@/lib/rate-limit"

// ===========================================
// Enum Labels (Database enum'ları ile uyumlu)
// ===========================================

// İlan Durumları
export const LISTING_STATUSES = {
  pending: { label: "Onay Bekliyor", color: "yellow" },
  active: { label: "Aktif", color: "green" },
  inactive: { label: "Pasif", color: "gray" },
  rejected: { label: "Reddedildi", color: "red" },
} as const;

// Kullanıcı Rolleri
export const USER_ROLES = {
  guest: { label: "Misafir", description: "Sadece ilanları görüntüleyebilir" },
  owner: { label: "Ev Sahibi", description: "İlan oluşturabilir ve yönetebilir" },
  admin: { label: "Yönetici", description: "Tüm sistemi yönetebilir" },
} as const;

// Para Birimleri
export const CURRENCIES = {
  TRY: { label: "TL", symbol: "₺", name: "Türk Lirası" },
  USD: { label: "USD", symbol: "$", name: "Amerikan Doları" },
  EUR: { label: "EUR", symbol: "€", name: "Euro" },
} as const;

// Şikayet Durumları
export const REPORT_STATUSES = {
  pending: { label: "Bekliyor", color: "yellow" },
  reviewed: { label: "İncelendi", color: "blue" },
  resolved: { label: "Çözüldü", color: "green" },
  dismissed: { label: "Reddedildi", color: "gray" },
} as const;

// Müsaitlik Durumları
export const AVAILABILITY_STATUSES = {
  available: { label: "Müsait", color: "green" },
  booked: { label: "Rezerve", color: "red" },
  blocked: { label: "Kapalı", color: "gray" },
} as const;

// İletişim Tipleri
export const CONTACT_TYPES = {
  phone: { label: "Telefon", icon: "phone" },
  whatsapp: { label: "WhatsApp", icon: "message-circle" },
  email: { label: "E-posta", icon: "mail" },
  website: { label: "Web Sitesi", icon: "globe" },
} as const;
